/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC } from "react";

import { HomeStyle } from "./styles";
import { Box } from "@mui/material";
import TemplatePage from "../TemplatePage";

import Page15TokenDMelt from "../../Page15TokenDMelt";

const Melt: FC = () => {
  return (
    <TemplatePage>
      <Box sx={HomeStyle.mainContainer}>
        <Page15TokenDMelt passedData={""} />
        <Box>
          <a
            href="https://arpt.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            style={HomeStyle.arptUrl}
          >
            ARPT
          </a>
        </Box>
      </Box>
    </TemplatePage>
    
  );
};

export default Melt;
